import React from "react";
import Fade from "react-reveal/Fade";
import "./Prj.scss";

const Prj = (props) => {
  return (
    <ul>
      {props.prj.map((prj, i) => (
        <li key={i}>
          <Fade top cascade>
            <div className="prj-content">
              <h3 className="prj-overline">{prj.overline}</h3>
              <h2 className="prj-title">{prj.title}</h2>
              <div className="prj-desc">
                <p>{prj.description}</p>
              </div>
              <ol className="prj-techlist">
                {prj.techlist.map((el, i) => (
                  <li key={i}>{el}</li>
                ))}
              </ol>
              <div className="prj-links">
                {prj.links.map((el, i) => (
                  <a key={i} href={el.link}>
                    {el.img}
                  </a>
                ))}
              </div>
            </div>
          </Fade>
            <div className="prj-img">
              <img src={prj.image} />
              <div className="overlay"></div>
            </div>
        </li>
      ))}
    </ul>
  );
};

export default Prj;
